/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Domains, getDomain } from '@sembo-private/utils';

import { BannerActivity } from '@libs/trip-planner-interfaces';

export type BannerActivityInfo = {
  activityCode: string;
  activityName: BannerActivity;
  polygons: number[];
  includedHotelCodes: string[];
  openingDate?: Date;
  closingDate?: Date;
  allowedMarkets?: Domains[];
  excludedMarkets?: Domains[];
  imageUrls: {
    lowRes: string;
    hiRes: string;
  };
};

const legolandBannerActivityInfo: BannerActivityInfo = {
  activityCode: '3256042',
  activityName: BannerActivity.Legoland,
  polygons: [
    357239, // Billund, Danmark
    357808, // Give, Danmark
    357614, // Risskov, Danmark
    357085, // Vejle, Danmark
    606024, // LEGOLAND® Billund, Jutland, Denmark
    357958, // Grindsted, Denmark
    357246, // Brande, Denmark
    357281, // Hovborg, Danmark
    357234, // Givskud, Give, Danmark
  ],
  includedHotelCodes: [],
  openingDate: new Date('2024-03-23'),
  closingDate: new Date('2024-10-31'),
  excludedMarkets: [Domains.DENMARK],
  imageUrls: {
    hiRes: 'https://images.sembo.travel/trip-planner/legoland_2.jpg',
    lowRes: 'https://images.sembo.travel/trip-planner/legoland_2.jpg',
  },
};

// const disneylandBannerActivityInfo: BannerActivityInfo = {
//   activityCode: '3303418',
//   activityName: BannerActivity.Disneyland,
//   polygons: [
//     361048, // Disneyland® Paris, Disneyland, Paris, Frankrike
//     395939, // Bailly-Romainvilliers, Frankrike
//     376714, // Chessy, Frankrike
//     389219, // Coupvray, Frankrike
//     363848, // Magny le Hongre, Frankrike
//     362474, // Paris, Frankrike
//     360765, // Ile-de-France, Frankrike
//     360859, // Marne-la-Vallee, Frankrike
//     360749, // Seine-et-Marne (department), Frankrike
//     393487, // Montguyon, France
//     393430, // Villiers-sur-Morin, France
//     395884, // Serris, France
//     363842, // Chanteloup-en-Brie, France
//     374190, // Montevrain, France
//     395145, // Bussy-Saint-Georges, France
//     373463, // Bussy-Saint-Martin, France
//     390591, // Jossigny, France
//     361708, // Chalifert, France
//     367783, // Coutevroult, France
//     372517, // Dainville, France
//     363823, // Torcy, France
//     363608, // Lagny-sur-Marne, France
//   ],
//   includedHotelCodes: [
//     'F-7110',
//     'F-7111',
//     'F-7112',
//     'F-7113',
//     'F-7114',
//     'F-7115',
//   ],
//   allowedMarkets: [
//     Domains.SWEDEN,
//     Domains.NORWAY,
//     Domains.DENMARK,
//     Domains.FINLAND,
//   ],
//   imageUrls: {
//     hiRes: 'https://images.sembo.travel/trip-planner/disneyland_0.jpg',
//     lowRes: 'https://images.sembo.travel/trip-planner/disneyland_2.jpg',
//   },
// };

export const bannerActivities: BannerActivityInfo[] = [
  legolandBannerActivityInfo,
  // disneylandBannerActivityInfo,
];

export function getBannerActivityInfo(
  polygonId: number
): BannerActivityInfo | undefined {
  return bannerActivities.find((activity) =>
    activity.polygons.includes(polygonId)
  );
}

export function isBannerActivityAllowedInCurrentMarket(
  bannerActivityInfo: BannerActivityInfo
): boolean {
  const currentDomain = getDomain.getCurrentDomainSpec().Domain;

  const bannerActivityIsAllowed =
    !bannerActivityInfo.allowedMarkets ||
    bannerActivityInfo.allowedMarkets.some(
      (allowedMarket) =>
        getDomain.getDomainSpec(allowedMarket).Domain === currentDomain
    );

  const bannerActivityIsBlocked = !!bannerActivityInfo.excludedMarkets?.some(
    (exludedMarket) =>
      getDomain.getDomainSpec(exludedMarket).Domain === currentDomain
  );

  return bannerActivityIsAllowed && !bannerActivityIsBlocked;
}
